/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import noUiSlider from 'nouislider'
import { useLayout } from '../../core'
import { DefaultTitle } from './page-title/DefaultTitle'
import { generateToken, messaging } from '../../../../app/modules/auth/components/firebase'
import { fetchData } from '../../../../reusable'
import { Toaster, toast } from 'react-hot-toast'
import { HeaderNotificationsMenu } from '../../../partials'
import clsx from 'clsx'
import { onMessage } from 'firebase/messaging'

const HeaderToolbar = () => {
  const { classes } = useLayout()

  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
    toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px'

  const [unreadNotificationCount, setUnreadNotificationCount] = useState('') as any
  const [showNotifications, setShowNotifications] = useState(0) // 0 means hidden, 1 means show

  const unreadNotificationCountApiCall = async () => {

    try {
      const tmp2 = sessionStorage.getItem('admin');
      let adminId;

      if (tmp2) {
        const adminData = JSON.parse(tmp2);
        adminId = adminData.adminId;
      }

      if (!adminId) throw new Error("Admin ID not found in session storage");

      const param = { adminId };
      const response: any = await fetchData('admin/unreadnotification', param);

      if (response.status == '200') {
        setUnreadNotificationCount(response.data.count);
      } else {
        console.error("Error fetching unread notifications:", response);
      }
    } catch (error) {
      console.error("Error in unreadNotificationCountApiCall:", error);
    }
  };


  useEffect(() => {
    if (showNotifications == 0) {
      unreadNotificationCountApiCall()
    }
  }, [showNotifications && width > 991])

  useEffect(() => {
    const fetchToken = async () => {
      var tmp: any = sessionStorage.getItem('admin')
      tmp = JSON.parse(tmp)
      var adminId: any = tmp['adminId']

      const fcmToken = await generateToken()
      if (fcmToken) {
        var param: any = {
          adminId: adminId,
          token: fcmToken,
        }
        var response: any = await fetchData('admin/savefcmtoken', param)
        if (response.status == '200') {
        } else {
        }
      }
    }

    fetchToken()

    onMessage(messaging, (payload: any) => {
      unreadNotificationCountApiCall()
      toast.success(`${payload.notification.title}: ${payload.notification.body}`, {
        duration: 6000,
        position: 'top-center',
      })
      // toastsuccessmsg(`${payload.notification.title}: ${payload.notification.body}`)
    })
  }, [])

  useEffect(() => {
    const rangeSlider = document.querySelector('#kt_toolbar_slider')
    const rangeSliderValueElement = document.querySelector('#kt_toolbar_slider_value')

    if (!rangeSlider || !rangeSliderValueElement) {
      return
    }

    // @ts-ignore
    noUiSlider.create(rangeSlider, {
      start: [5],
      connect: [true, false],
      step: 1,
      format: {
        to: function (value) {
          const val = +value
          return Math.round(val).toString()
        },
        from: function (value) {
          return value
        },
      },
      range: {
        min: [1],
        max: [10],
      },
    })

    // @ts-ignore
    rangeSlider.noUiSlider.on('update', function (values, handle) {
      rangeSliderValueElement.innerHTML = values[handle]
    })

    const handle = rangeSlider.querySelector('.noUi-handle')
    if (handle) {
      handle.setAttribute('tabindex', '0')
    }

    // @ts-ignore
    handle.addEventListener('click', function () {
      // @ts-ignore
      this.focus()
    })

    // @ts-ignore
    handle.addEventListener('keydown', function (event) {
      // @ts-ignore
      const value = Number(rangeSlider.noUiSlider.get())
      // @ts-ignore
      switch (event.which) {
        case 37:
          // @ts-ignore
          rangeSlider.noUiSlider.set(value - 1)
          break
        case 39:
          // @ts-ignore
          rangeSlider.noUiSlider.set(value + 1)
          break
      }
    })
    return () => {
      // @ts-ignore
      rangeSlider.noUiSlider.destroy()
    }
  }, [])

  return (
    <>
      {/* <ToastContainer /> */}
      <Toaster />
      <div className='toolbar d-flex align-items-stretch'>
        {/* begin::Toolbar container */}
        <div
          className={`${classes.headerContainer.join(
            ' '
          )} py-6 py-lg-0 d-flex flex-column flex-lg-row align-items-lg-stretch justify-content-lg-between`}
        >
          <DefaultTitle />
          <div className='d-flex align-items-stretch overflow-auto pt-3 pt-lg-0'>
            {/* begin::Action wrapper */}
            <div className='d-flex align-items-center'></div>
            {/* end::Action wrapper */}
          </div>
          {/* end::Toolbar container */}
        </div>
        {width > 991 ?

          <div className='d-flex justify-content-start mx-10 align-items-center'>
            <div
              className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
              style={{ position: 'relative' }}
            >
              <div
                className={clsx(
                  'btn btn-icon btn-active-light-primary btn-custom',
                  toolbarButtonHeightClass
                )}
                data-kt-menu-trigger='click'
                data-kt-menu-attach='parent'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-flip='bottom'
                onClick={() => {
                  setUnreadNotificationCount(0)
                  setShowNotifications((prev) => (prev === 0 ? 1 : 0))
                }}
              >
                <i className='ki-solid ki-notification-on fs-1 text-dark'></i>
              </div>
              <HeaderNotificationsMenu show={showNotifications} />

              <span
                style={{
                  position: 'absolute',
                  top: '-5px',
                  right: '-12px',
                  backgroundColor: '#d9534f',
                  color: '#fff',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  borderRadius: '50%',
                  minWidth: '20px', // Ensures minimum size
                  padding: '2px 6px', // Dynamic padding for larger text
                  height: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
                  whiteSpace: 'nowrap', // Prevent wrapping
                  textOverflow: 'ellipsis', // Add ellipsis for overflow
                  overflow: 'hidden',
                }}
              >
                {unreadNotificationCount >= 99 ? '99' : unreadNotificationCount}
                {/* 99 */}
              </span>
            </div>
          </div> : ""}
      </div>
    </>
  )
}

export { HeaderToolbar }
